// Registro do service worker do PWA. Só roda em produção/https (localhost também
// é permitido pelo navegador) — em ambiente sem suporte, não faz nada.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // Lote 63: ao voltar pra tela, pede ao navegador pra conferir se há service worker
        // novo (por padrão ele só confere ao navegar e de tempos em tempos).
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") registration.update().catch(() => {});
        });
      })
      .catch(() => {
        // Falha ao registrar não deve quebrar o app — o IApauta funciona
        // normalmente pelo navegador mesmo sem o service worker.
      });
  });
}
